import { useMemo } from 'react'
import LocalStorageService from '../services/LocalStorageService'
import jwt_decode from 'jwt-decode'

// JWT token decoded example:
// {
//   name: 'ADMIN',
//   email: 'admin@ecbr.com.br',
//   role: 'ADMIN_ECBR',
//   iat: 1646996142,
//   exp: 1647082542
// }

const useAuthToken = () =>
  useMemo(() => {
    const token = LocalStorageService.get('token')
    if (!token) return {}
    try {
      const decoded = jwt_decode(token)
      if (!decoded || decoded.exp < Date.now() / 1000) {
        LocalStorageService.remove('token')
        return {}
      }

      return decoded
    } catch (error) {
      LocalStorageService.remove('token')
      return {}
    }
  }, [])

export default useAuthToken
